import React, { useState, useEffect, Fragment } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';

import { makeStyles } from '@material-ui/core/styles';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { Add, Create, Domain } from '@material-ui/icons';
import Button from 'components/CustomButtons/Button.js';
import { WithApp } from 'contexts/appContext';
import { Toasty, useToasty } from 'hooks/Toasty';
import { useModal } from 'hooks/useModal';
import ModalBTurn from './Modal';
import { TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { wsFindBy } from 'services/WService';
import ButtonDelete from 'hooks/ButtonDelete';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
};

const useStyles = makeStyles(styles);

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 130 },
  { Header: 'Socio negocio / Proveedor', accessor: 'bPartner' },
  { Header: 'Código', accessor: 'code', width: 100, align: 'center' },
  { Header: 'Descripción', accessor: 'description' },
  { Header: 'Estado', accessor: 'state', width: 100, align: 'center' },
  {
    Header: 'Incluir en config. promoción',
    accessor: 'promotion_list',
    align: 'center',
    width: 250,
  },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

export default WithApp(function BusinessTurn(props) {
  const classes = useStyles();
  const [notify, showNotify] = useToasty();

  const [bTurns, setBTurns] = useState([]);
  const [model, setOpen] = useModal();

  const [bPartners, setBpartners] = useState([]);
  const [bPartnerSelect, setBpartnerSelect] = useState('T');
  
  const [dataLoading, setDataLoading] = useState(false);

  async function getBusinessTurns(bPartnerSelect) {
    let search = { base_business_partner_id: bPartnerSelect };
    if (search.base_business_partner_id == 'T') {
      search = { base_business_partner_id: '' };
    }
    setDataLoading(true);
    setBTurns([]);
    let response = await wsFindBy('base/business-line', search);
    setDataLoading(false);
    if (response.success) setBTurns(response.data);
  }

  async function listBpartners() {
    let response = await wsFindBy('base/business-partner', { CardType: 'S', QryGroup1: 'Y' });
    if (response.success) {
      setBpartners(response.data);
    }
  }

  useEffect(() => {
    getBusinessTurns(bPartnerSelect);
  }, [bPartnerSelect]);

  useEffect(() => {
    listBpartners();
  }, []);

  return (
    <Fragment>
      <Toasty action={notify} />
      <ModalBTurn
        model={model}
        setOpen={setOpen}
        showNotify={showNotify}
        reload={getBusinessTurns}
        bPartners={bPartners}
      />

      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader icon>
              <AllowedGuard
                permission={ConstantPermissions.BASE_BUSINESS_LINES_STORE}
                component={
                  <CardIcon color="primary">
                    <Domain style={{ color: 'white' }} />
                  </CardIcon>
                }
              >
                <CardIcon
                  onClick={() => setOpen({})}
                  pointer="true"
                  color={props.themeContext.buttonColorSuccess}
                >
                  <Add />
                </CardIcon>
              </AllowedGuard>
              <h4 className={classes.cardIconTitle}>Listado de giros de negocio {dataLoading && <LoadingSpinner />}</h4>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12} lg={4}>
                  <Autocomplete
                    options={bPartners}
                    getOptionLabel={(option) => option.CardName}
                    renderInput={(params) => (
                      <TextField {...params} label="Socio negocio / provedor" margin="normal" />
                    )}
                    onChange={(e, item) => {
                      !!item ? setBpartnerSelect(item.id) : setBpartnerSelect('T');
                    }}
                  />
                </GridItem>
              </GridContainer>

              <ReactTable
                excelName="Giros-de-negocio"
                defaultWidth={1200}
                columns={columns}
                data={bTurns.map((bTurn, i) => {
                  return {
                    num: (
                      <div className="actions-right">
                        {i + 1}
                        <AllowedGuard permission={ConstantPermissions.BASE_BUSINESS_LINES_UPDATE}>
                          <Button
                            justIcon
                            round
                            simple
                            color={props.themeContext.buttonColorWarning}
                            onClick={() => {
                              setOpen(bTurn);
                            }}
                          >
                            <Create />
                          </Button>
                        </AllowedGuard>
                        <AllowedGuard permission={ConstantPermissions.BASE_BUSINESS_LINES_DELETED}>
                          <ButtonDelete
                            entity="base/business-line"
                            id={bTurn.id}
                            reload={getBusinessTurns}
                          />
                        </AllowedGuard>
                      </div>
                    ),
                    bPartner: bTurn.CardName,
                    code: bTurn.code,
                    description: bTurn.description,
                    state: bTurn.state === 'A' ? 'Activo' : 'Inactivo',
                    promotion_list: bTurn.promotion_list === 'Y' ? 'Si' : 'No',
                    actions: '',
                  };
                })}
              />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </Fragment>
  );
});
